(function(){


    function SendAPI(){
        var self = this;
        this.init = function(obj) {
            var unindexed_array = obj.serializeArray();
            var indexed_array = {};

            $.map(unindexed_array, function(n, i){
                indexed_array[n['name']] = n['value'];
            });

            var cEmail = this.checkEmail(indexed_array.email);
            var country = indexed_array.country;
            var source = indexed_array.source;
            var cPrivacy = this.checkPrivacy(indexed_array.privacy);
            var type = indexed_array.type;

            this.showAlert(cEmail,cPrivacy);
            if(cEmail && cPrivacy){
                this.sendAPI(indexed_array.email,type,country,source);
            }
        }

        this.checkEmail = function(email){
            if(email){
                return this.validateEmail(email);
            }
            return false;
        }

        this.checkPrivacy = function(privacy){
            if(privacy){
                return true;
            }
            return false;
        }

        this.showAlert = function (cEmail,cPrivacy){
            if(!cEmail){
                $('.error_email').show();
            }else{
                $('.error_email').hide();
            }

            if(!cPrivacy){
                $('.error_privacy').show();
            }else{
                $('.error_privacy').hide();
            }
        }

        this.validateEmail = function(email){
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }

        this.sendAPI = function(Email,type,country,source){
            if(type){
                var data = '{"identifiers":[{"channels":{"email":{"status":"subscribed"}},"id":"'+Email+'","type":"email"}],"gender":"'+type+'","country":"'+country+'","tags": ["source: '+source+'"]}';
            }else{
                var data = '{"identifiers":[{"channels":{"email":{"status":"subscribed"}},"id":"'+Email+'","type":"email"}],"country":"'+country+'","tags": ["source: '+source+'"]}';
            }

                const settings = {
                    async: true,
                    crossDomain: true,
                    url: 'https://api.omnisend.com/v3/contacts',
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-API-KEY': '5cb045028653ed5a9883dbba-ZMh8bLEKWxJeKze4ejs2e923VDRVaRy5taEK5UQrsTpB5N60pn'
                    },
                    processData: false,
                    data: data
                };

                $.ajax(settings).done(function (response) {
                    if(response.contactID){
                        var $success_email = $('.success_email');
                        $('.newsletter_email').hide();
                        $('.error_send_email').hide();
                        $success_email.show();
                        if(source === 'form_ediscom' && $success_email.find('iframe').length <= 0){
                            $success_email.append('<iframe src="//www.trackads.eu/wPSdMJqD0cKWtgI6/1/" style="border:0;" width="1" height="1"></iframe>');
                        }
                    }else{
                        $('.error_send_email').show();
                    }
                });
        }

    }

    $('.subscribe_newsletter').on('click', function (e) {
        e.preventDefault();
        var formNs = $('.newsletter_email');
        new SendAPI().init(formNs);
        return false;
    });

    $('.subscribe_newsletter_page').on('click', function (e) {
        e.preventDefault();
        var formNs = $('.newsletter_email_page');
        new SendAPI().init(formNs);
        return false;
    });
})();
